import React, { useState, useEffect } from 'react';

const LiveAgentStatus = () => {
  const states = [
    'CALLING',
    'LISTENING',
    'REASONING',
    'CALLING API',
    'UPDATING SYSTEM',
    'VERIFYING',
    'COMPLETE'
  ];

  const [currentState, setCurrentState] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentState((prev) => (prev + 1) % states.length);
    }, 1500);

    return () => clearInterval(interval);
  }, [states.length]);

  return (
    <div className="inline-flex items-center space-x-3 px-6 py-3 bg-gray-900/80 border border-gray-700 rounded-full backdrop-blur-sm">
      <div className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500" />
      </div>
      <span className="text-sm font-mono text-blue-400 tracking-wider">
        {states[currentState]}
      </span>
    </div>
  );
};

export default LiveAgentStatus;